var _effectorFileName = "/builds/gmini/front-common/src/ErrorBoundary/ErrorBoundary.tsx";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import * as React from 'react';
import * as Sentry from '@sentry/react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function connectSentry(_ref) {
  var dsn = _ref.dsn,
      release = _ref.release,
      environment = _ref.environment;
  Sentry.init({
    dsn: dsn,
    release: release,
    environment: environment,
    debug: environment === 'development' ? true : false,
    beforeSend: function beforeSend(event, hint) {
      var _error$message, _event$message;

      var error = hint === null || hint === void 0 ? void 0 : hint.originalException;
      var excludeSafeErrorsRegexp = /Re[s\u017F]izeOb[s\u017F]erver loop limit exceeded/gim;
      var isSafeError = (error && typeof error !== 'string' ? (_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.match(excludeSafeErrorsRegexp) : error === null || error === void 0 ? void 0 : error.match(excludeSafeErrorsRegexp)) || ((_event$message = event.message) === null || _event$message === void 0 ? void 0 : _event$message.match(excludeSafeErrorsRegexp));

      if (isSafeError) {
        return null;
      }

      return event;
    },
    beforeBreadcrumb: function beforeBreadcrumb(breadcrumb) {
      // Временно фильтруем бредкрамбы c появлением (FSK-672 - front: Настроить логирование effector)
      // в массив бредкрамбов передаются console.log с данными сторов эффектора, запрос в сентри падает с 413 ошибкой
      if (breadcrumb.category === 'console' || breadcrumb.level === 'log') {
        return null;
      }

      return breadcrumb;
    }
  });
  var ErrorBoundary = /*#__PURE__*/React.memo(function (_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/_jsx(Sentry.ErrorBoundary, {
      fallback: /*#__PURE__*/_jsx(_Fragment, {
        children: "An error has occurred"
      }),
      children: children
    });
  });
  ErrorBoundary.displayName = 'ErrorBoundary';
  return {
    ErrorBoundary: ErrorBoundary
  };
}